export const toInputName = (str: string) => {
  // Map of diacritics to their normal character equivalents
  const diacriticsMap: Record<string, string> = {
    ă: 'a',
    â: 'a',
    á: 'a',
    à: 'a',
    ä: 'a',
    ã: 'a',
    å: 'a',
    Ă: 'A',
    Â: 'A',
    Á: 'A',
    À: 'A',
    Ä: 'A',
    Ã: 'A',
    Å: 'A',
    é: 'e',
    è: 'e',
    ê: 'e',
    ë: 'e',
    É: 'E',
    È: 'E',
    Ê: 'E',
    Ë: 'E',
    î: 'i',
    í: 'i',
    ì: 'i',
    ï: 'i',
    Î: 'I',
    Í: 'I',
    Ì: 'I',
    Ï: 'I',
    ó: 'o',
    ò: 'o',
    ô: 'o',
    ö: 'o',
    õ: 'o',
    Ó: 'O',
    Ò: 'O',
    Ô: 'O',
    Ö: 'O',
    Õ: 'O',
    ú: 'u',
    ù: 'u',
    û: 'u',
    ü: 'u',
    Ú: 'U',
    Ù: 'U',
    Û: 'U',
    Ü: 'U',
    ș: 's',
    ş: 's',
    Ș: 'S',
    Ş: 'S',
    ț: 't',
    ţ: 't',
    Ț: 'T',
    Ţ: 'T',
    ç: 'c',
    Ç: 'C',
    ñ: 'n',
    Ñ: 'N',
    ý: 'y',
    ÿ: 'y',
    Ý: 'Y',
  };

  return str
    .replace(/[\u0080-\uFFFF]/g, (char) => diacriticsMap[char] || char) // replace diacritics
    .toLowerCase() // make everything lowercase
    .replace(/[^a-z0-9]+(.)?/g, (_, chr) => (chr ? chr.toUpperCase() : '')) // remove spaces & special chars
    .replace(/^[0-9]+/, ''); // ensure it doesn't start with a number
};
